import { createSelector } from 'reselect'
import {
  CountryListModel,
  CountryListResponse,
} from 'src/models/country.models'
import { RootState } from 'src/redux/createRootReducer'

const selectCountryListResponsesFromState = (
  state: RootState,
): Record<string, CountryListResponse> => state.data.countrys.listResponses
const selectCountryOrderFromState = (state: RootState): string[] =>
  state.data.countrys.order

export const selectCountryListModelsFromState = createSelector(
  [selectCountryListResponsesFromState],
  (creditCardListResponses) =>
    Object.values(creditCardListResponses).reduce<
      Record<CountryListResponse['iso'], CountryListModel>
    >(
      (acc, curr) => ({
        ...acc,
        [curr.iso]: new CountryListModel(curr),
      }),
      {},
    ),
)

export const selectCountryListModelList = createSelector(
  [selectCountryListModelsFromState, selectCountryOrderFromState],
  (countrys, isoList) => isoList.map((iso) => countrys[iso]),
)

export const selectCountryOptions = createSelector(
  [selectCountryListModelList],
  (countrys) =>
    countrys.map((country) => ({
      value: country.iso,
      details: {
        text: country.label,
      },
    })),
)
